import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from 'react-lazy-load-image-component';


function ImageSection(props) {

  return (
    <section>
      <div className="full-section-bg">
        <LazyLoadImage
          alt="Project showcase image"
          src={props.content.sectionImg} />
      </div>
    </section>
  )
}

ImageSection.propTypes = {
  content: PropTypes.shape({
    sectionImg: PropTypes.string.isRequired
  }).isRequired
};

export default ImageSection;
